import React from "react";
import HomeVideo from "../../assets/images/test2.gif"

export default function HomeBanner() {
  return (
    <div className="header-content min-h-screen dark:bg-content w-full flex items-center justify-center text-sky-800 dark:text-sky-500">
      <div className="flex flex-col items-center md:w-10/12 w-11/12 py-20">
        <div className="grid gap-10 md:grid-cols-2 w-full">
          <div className="mt-16 md:mt-0 md:flex flex-col justify-center">
            <h1
              data-aos="fade-right"
              className="text-sky-800 dark:text-white text-3xl md:text-6xl font-bold"
            >
              Google Developer Student Clubs{" "}
              <span className="dark:text-sky-500">
                UIT
              </span>
            </h1>
            <p
              data-aos="fade-right"
              data-aos-delay="200"
              className="mt-5 mb-3 text-gray-500 dark:text-gray-400"
            >
             ⚡GDSC-UIT empowers all the students to not only build solutions for the community but to overcome their technical barriers too by Connecting, Learning, and Growing together.
            </p>
            <a href="https://developers.google.com/community/gdsc" target="__blank"
              data-aos="fade-right"
              data-aos-delay="300"
              className="mt-5 w-48 bg-sky-100 dark:bg-sky-500 dark:text-white text-sky-800 transition-all px-8 py-3 rounded-full hover:shadow-xl hover:shadow-black/10"
            >
              Discover GDSC
            </a>
          </div>
          <div className="">
            <img src={HomeVideo} className="w-full" alt="" />
            <div
          // className="embed-responsive embed-responsive-4by3 relative w-full overflow-hidden"
        >
          {/* <video class="w-full shadow-lg" autoPlay loop muted> */}
          {/* <source autoPlay src={HomeVideo} type="video/mp4" /> */}
        {/* </video> */}


        </div>
          </div>
        </div>
        <div className="w-full mt-24 mb-5 grid md:grid-cols-4 gap-10">
          <div>
            <h1 className="text-4xl font-bold">1 Million+</h1>
            <p className="mt-2 text-gray-500 dark:text-gray-400 ">
              Students and professionals linked with community
            </p>
          </div>
          <div>
            <h1 className="text-4xl font-bold">1500+</h1>
            <p className="mt-2 text-gray-500 dark:text-gray-400 ">
            College and university chapters around the globe
            </p>
          </div>
          <div>
            <h1 className="text-4xl font-bold">100+</h1>
            <p className="mt-2 text-gray-500 dark:text-gray-400 ">
              Countries containing google developer student clubs
            </p>
          </div>
          <div>
            <h1 className="text-4xl font-bold">100%</h1>
            <p className="mt-2 text-gray-500 dark:text-gray-400">
              Chances of growth
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
